import styled from "styled-components";

interface IButton {
  name?: any;
  Icon?: any;
  onClick?: () => void;
  type?: "button" | "submit" | "reset"; // Tipos de botão válidos
  disable?: boolean
}

export default function ActionButton({
  name,
  Icon,
  onClick,
  type = "button",
  disable = false
}: IButton) {
  return (
    <Container
      type={type}
      onClick={onClick}
      disabled={disable}
    >
      {name && <p>{name}</p>}
      {Icon}
    </Container>
  );
}

const Container = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  border-radius: 4px;
  padding: 8px 10px;
  min-width: 125px;
  
  color: ${(props) => props.theme.colors.white};
  background-color: ${(props) => props.theme.colors.primary};

  font-weight: 500;
  font-size: 16px;
  white-space: nowrap;

  &:hover {
    background-color: ${(props) => props.theme.colors.red.red_800};
  }
  &:disabled{
    cursor: not-allowed;
    background-color: ${(props) => props.theme.colors.red.red_800};
  }
`;
